import { useAppContext } from "../../../../AppContext";
import { UserRole } from "../../../../common/enums";
import { getCurrentUserRole } from "../../../../common/infrastructure/helpers/userHelper";
import { useAiAssistantStatus } from "../../../aiAssistant/hooks/useAiAssistantStatus";

export type SupportHomeView = "loading" | "assistant" | "tickets";

/**
 * Which page "/support" shows: the AI assistant for staff while it is enabled, the tickets list
 * otherwise. GlobalAdmin answers the tickets, so it always gets the list; any trouble reading
 * the assistant's status also falls back to the list, so support is never out of reach.
 */
export const useSupportHome = (): { view: SupportHomeView } => {
  const { currentUser } = useAppContext();
  const isGlobalAdmin = getCurrentUserRole(currentUser) === UserRole.GlobalAdmin;
  const { status, isLoading, isError } = useAiAssistantStatus(!isGlobalAdmin);

  if (isGlobalAdmin || isError) return { view: "tickets" };
  if (isLoading) return { view: "loading" };
  return { view: status?.enabled ? "assistant" : "tickets" };
};
